import React from "react";
import { useSearchParams } from "react-router-dom";
import ProjectOrganisationOverview from "./overview";
import ProjectOrganisationPlanDetails from "./plan-details";
import ProjectFilePlanContextProvider from "./plan-details/context/project-file-plan-context-provider.tsx";
import ModelingToolsContextProvider from "../../../../../services/context/viewer/modeling-tools/modeling-tools-context-provider.tsx";

const ProjectOrganisationLayout: React.FC = () => {
    const [searchParams] = useSearchParams();
    const fileId = (searchParams.get('fileId') as string);

    return fileId != null ? (
        <ModelingToolsContextProvider>
            <ProjectFilePlanContextProvider fileId={fileId}>
                <ProjectOrganisationPlanDetails />
            </ProjectFilePlanContextProvider>
        </ModelingToolsContextProvider>
    ) : (
        <ProjectOrganisationOverview />
    )
}

export default ProjectOrganisationLayout;